import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import { getUsers, makeUserAdmin } from "../../../redux/slices/adminSlice";
import { useDispatch, useSelector } from "react-redux";
import { getMe } from "../../../redux/slices/userSlice";
import {
  Button,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";

const UsersTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const allUsers = useSelector((state) => state.admin.allUsers);
  const getUsersLoading = useSelector((state) => state.admin.getUsersLoading);
  const totalUsersCount = useSelector((state) => state.admin.totalUsersCount);

  const columns = [
    { id: "emailVerified", label: t("adminUsers.verified"), minWidth: 170 },
    { id: "username", label: t("adminUsers.username"), minWidth: 170 },
    { id: "email", label: t("adminUsers.email"), minWidth: 100 },
    {
      id: "phone",
      label: t("adminUsers.phone"),
      minWidth: 170,
    },
    {
      id: "current_points",
      label: t("adminUsers.points"),
      minWidth: 170,
    },
    { id: "ACL", label: t("adminUsers.userType"), minWidth: 100 },
    // {
    //   id: "action",
    //   label: t("adminUsers.action"),
    //   minWidth: 100,
    // },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    dispatch(getMe()).then((res) => {
      dispatch(getUsers({ pageSize: rowsPerPage, pageNum: page + 1 }));
    });
  }, [dispatch, rowsPerPage, page]);

  const getIconForVerify = (value) => {
    return value ? <CheckCircleIcon /> : <DoDisturbIcon />;
  };
  const getColumRole = (value) => {
    return value === "ROLE_ADMIN" ? (
      <Chip color="error" label={t("adminUsers.admin")}></Chip>
    ) : (
      <Chip label={t("adminUsers.regular")}></Chip>
    );
  };
  const getColumnAction = (value) => {
    const isAdmin = value.role === "ROLE_ADMIN";
    if (isAdmin) {
    }
    return (
      <Button
        onClick={() => toggleAdmin(isAdmin, value.user)}
        variant="contained"
        color={isAdmin ? "error" : "info"}
      >
        {t(isAdmin ? "adminUsers.removeAdmin" : "adminUsers.makeAdmin")}
      </Button>
    );
  };
  const toggleAdmin = (isAdmin, user) => {
    !isAdmin &&
      dispatch(makeUserAdmin({ user })).then((response) =>
        dispatch(getMe()).then((res) => {
          dispatch(getUsers({ pageSize: rowsPerPage, pageNum: page }));
        })
      );
  };

  return (
    <>
      {getUsersLoading === "PENDING" ? (
        <Stack
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <Typography component="div" marginBottom="24px" fontWeight={600}>
            {t("adminUsers.totalUsers", { num: totalUsersCount })}
          </Typography>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allUsers?.map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.user.objectId}
                      >
                        {columns.map((column) => {
                          const value = row.user[column.id];
                          return (
                            <TableCell key={column.id}>
                              {column.id === "emailVerified"
                                ? getIconForVerify(value)
                                : column.id === "ACL"
                                ? getColumRole(row.role)
                                : column.id === "action"
                                ? getColumnAction(row)
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={totalUsersCount || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </>
      )}
    </>
  );
};
export default UsersTable;
